// extracted by mini-css-extract-plugin
export default {"wrapper":"EditableContent_wrapper__rThlL","header":"EditableContent_header__O7yuq","body":"EditableContent_body__ZZw7Q"};